"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reactBootstrap = require("react-bootstrap");

var _react = _interopRequireDefault(require("react"));

var _Headline = _interopRequireDefault(require("../headline/Headline"));

var _SectionContainerModule = _interopRequireDefault(require("./SectionContainer.module.scss"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const SectionContainer = props => {
  return /*#__PURE__*/_react.default.createElement("section", {
    className: _SectionContainerModule.default.sectionContainer
  }, /*#__PURE__*/_react.default.createElement(_Headline.default, {
    text: props.headline
  }), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Container, {
    fluid: true,
    className: _SectionContainerModule.default.sectionWrapper
  }, props.children));
};

var _default = SectionContainer;
exports.default = _default;